(function () {
  'use strict';
  var SCROLL_THRESHOLD = 40;
  var SCROLLED_CLASS = 'header-tactical-scrolled';
  var ticking = false;

  function updateHeader() {
    var scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    var html = document.documentElement;
    var body = document.body;

    if (scrollY > SCROLL_THRESHOLD) {
      html.classList.add(SCROLLED_CLASS);
      if (body) body.classList.add(SCROLLED_CLASS);
    } else {
      html.classList.remove(SCROLLED_CLASS);
      if (body) body.classList.remove(SCROLLED_CLASS);
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  function init() {
    updateHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
